import { ReactElement } from "react";
import Section, {
  DisplaySectionType,
  GeometrySectionType,
  InputSectionType,
} from "../../types/Section";
import DisplayControl from "./controls/DisplayControl";
import "./SectionRenderer.scss";

interface SectionRendererProps {
  section: Section;
}

function SectionRenderer({
  section,
}: SectionRendererProps): ReactElement | null {
  switch (section.type) {
    case DisplaySectionType.heading:
    case DisplaySectionType.text:
    case DisplaySectionType.image:
      return null;

    case InputSectionType.text:
    case InputSectionType.text_area:
    case InputSectionType.url:
    case InputSectionType.date:
    case InputSectionType.integer:
    case InputSectionType.decimal:
    case InputSectionType.boolean:
    case InputSectionType.list:
    case InputSectionType.multiselect_list:
    case InputSectionType.rating:
    case InputSectionType.media:
    case GeometrySectionType.geometry_point:
    case GeometrySectionType.geometry_line:
    case GeometrySectionType.geometry_polygon:
      return (
        <DisplayControl
          section={section}
          label={section.label}
          type={section.type}
          id={section.columnName}
          required={section.required}
        />
      );

    default:
      return <p>Not implemented: {section.type}</p>;
  }
}

export default SectionRenderer;
